export const LS_FAVOURITES = 'favourites';
export const LS_USER_TOKEN = 'user_token';
export const LS_CURRENCY = 'user_currency';
